import { useState, useEffect, useCallback } from "react";
import DisArama from "./DisArama";
const API = "https://prestijcrm.duckdns.org/api";
const DURUMLAR = ["sicak","ilik","soguk","pasif"];
const KAYNAKLAR = ["Manuel","Instagram","Facebook","WhatsApp","Referans","Website","Diger"];
const ODALAR = ["1+0","1+1","2+1","3+1","4+1","5+1","6+"];
const AMACLAR = ["Oturum","Yatirim"];
const MULK_TIPLERI = [
  {k:"daire",a:"Daire"},{k:"mustakil",a:"Müstakil Ev"},{k:"villa",a:"Villa"},{k:"yazlik",a:"Yazlık"},
  {k:"dukkan",a:"Dükkan"},{k:"isyeri",a:"İşyeri"},{k:"fabrika",a:"Fabrika"},{k:"arsa",a:"Arsa"},{k:"tarla",a:"Tarla"},
];
const TIP_ADI = Object.fromEntries(MULK_TIPLERI.map(t=>[t.k,t.a]));
const KONUT = ["daire","mustakil","villa","yazlik"];
const GRUP_RENK = {1:"#10b981",2:"#3b82f6",3:"#f59e0b",4:"#64748b"};

// Cep telefonu ise 90XXXXXXXXXX dondurur, degilse ""
const cepNumarasi = (raw) => {
  let d = String(raw||"").replace(/\D/g,"");
  if (d.startsWith("0090")) d = d.slice(4);
  else if (d.startsWith("90") && d.length===12) d = d.slice(2);
  else if (d.startsWith("0")) d = d.slice(1);
  return /^5\d{9}$/.test(d) ? "90"+d : "";
};
const gosterNumara = (n) => { const d=String(n||"").replace(/\D/g,""); return d.length===12 ? `+${d.slice(0,2)} ${d.slice(2,5)} ${d.slice(5,8)} ${d.slice(8,10)} ${d.slice(10)}` : (n||""); };
const kayitBilgi = (t) => {
  if (!t) return {tarih:"-",once:"",rozet:null};
  const d = new Date(t), gun = Math.floor((Date.now()-d.getTime())/86400000);
  const once = gun<=0?"Bugün":gun===1?"Dün":gun<30?`${gun} gün önce`:gun<365?`${Math.floor(gun/30)} ay önce`:`${Math.floor(gun/365)} yıl önce`;
  const rozet = gun<7?{y:"YENİ",r:"#10b981"}:gun<30?{y:"Bu ay",r:"#3b82f6"}:gun<180?null:{y:"ESKİ",r:"#64748b"};
  return {tarih:d.toLocaleDateString("tr-TR",{day:"2-digit",month:"2-digit",year:"numeric"}),saat:d.toLocaleTimeString("tr-TR",{hour:"2-digit",minute:"2-digit"}),once,rozet,gun};
};
const bosForm = () => ({name:"",phone:"",whatsapp_number:"",email:"",budget_min:"",budget_max:"",bolgeler:[],kategoriler:[],islem:"satilik",rooms:"",type:"",source:"Manuel",status:"ilik",notes:"",hot_score:0,tags:""});

export default function Customers() {
  const token = localStorage.getItem("token");
  const headers = { "Content-Type":"application/json", Authorization:`Bearer ${token}` };
  const [musteriler, setMusteriler] = useState([]);
  const [stats, setStats] = useState({total:0,sicak:0,ilik:0,buAy:0,bugun:0});
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(bosForm());
  const [bolgeGiris, setBolgeGiris] = useState("");
  const [waOto, setWaOto] = useState(false);
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [yas, setYas] = useState("");
  const [sira, setSira] = useState("yeni");
  const [eslesme, setEslesme] = useState(null);
  const [eslesmeModal, setEslesmeModal] = useState(false);
  const [disMusteri, setDisMusteri] = useState(null);
  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const fetchAll = useCallback(async () => {
    const p = new URLSearchParams();
    if(search) p.append("search",search);
    if(filterStatus) p.append("status",filterStatus);
    const r = await fetch(`${API}/customers?${p}`,{headers});
    const d = await r.json();
    const list = d.customers||[];
    setMusteriler(list);
    const n = new Date();
    const buAy = list.filter(m=>{const t=new Date(m.created_at);return t.getMonth()===n.getMonth()&&t.getFullYear()===n.getFullYear();}).length;
    const bugun = list.filter(m=>new Date(m.created_at).toDateString()===n.toDateString()).length;
    setStats({total:d.total||0,sicak:list.filter(m=>m.status==="sicak").length,ilik:list.filter(m=>m.status==="ilik").length,buAy,bugun});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[search,filterStatus]);
  useEffect(()=>{fetchAll();},[fetchAll]);

  const acModal = (m=null) => {
    if (m) {
      const bolgeler = (m.bolgeler&&m.bolgeler.length) ? m.bolgeler : String(m.district||"").split(",").map(s=>s.trim()).filter(Boolean);
      setForm({...bosForm(),...m,phone:m.phone||"",whatsapp_number:m.whatsapp_number||"",email:m.email||"",notes:m.notes||"",rooms:m.rooms||"",type:m.type==="Kiralik"?"":(m.type||""),
        budget_min:m.budget_min?String(Math.round(m.budget_min)):"",budget_max:m.budget_max?String(Math.round(m.budget_max)):"",
        bolgeler,kategoriler:m.kategoriler||[],islem:m.islem||"satilik",tags:(m.tags||[]).join(", ")});
      setWaOto(false);
    } else { setForm(bosForm()); setWaOto(true); }
    setBolgeGiris(""); setEditId(m?m.id:null); setError(""); setModal(true);
  };

  // Telefon yazilinca: cep ise WhatsApp alanini otomatik doldur
  const telefonDegisti = (v) => {
    setForm(p=>{
      const cep = cepNumarasi(v);
      const oto = waOto || !p.whatsapp_number || p.whatsapp_number===cepNumarasi(p.phone);
      return {...p, phone:v, whatsapp_number: oto ? cep : p.whatsapp_number};
    });
  };

  const bolgeEkle = (metin) => {
    const yeni = String(metin||"").split(/[,;\n]/).map(s=>s.trim()).filter(Boolean);
    if (!yeni.length) return;
    setForm(p=>{ const set=[...p.bolgeler]; yeni.forEach(y=>{ if(!set.some(s=>s.toLocaleLowerCase("tr")===y.toLocaleLowerCase("tr"))) set.push(y); }); return {...p,bolgeler:set}; });
    setBolgeGiris("");
  };
  const bolgeSil = (b) => setForm(p=>({...p,bolgeler:p.bolgeler.filter(x=>x!==b)}));
  const tipDegistir = (k) => setForm(p=>({...p,kategoriler:p.kategoriler.includes(k)?p.kategoriler.filter(x=>x!==k):[...p.kategoriler,k]}));

  const sayi = (v) => { const s=String(v||"").replace(/\D/g,""); return s?Number(s):null; };
  const kaydet = async () => {
    if(!form.name){setError("Ad zorunlu");return;}
    if(!form.kategoriler.length){setError("En az bir mülk tipi seçin (Daire, Dükkan, Arsa...)");return;}
    const bolgeler = [...form.bolgeler]; if (bolgeGiris.trim()) bolgeGiris.split(/[,;\n]/).map(s=>s.trim()).filter(Boolean).forEach(b=>{ if(!bolgeler.includes(b)) bolgeler.push(b); });
    const url = editId?`${API}/customers/${editId}`:`${API}/customers`;
    const tagsArr = form.tags ? String(form.tags).split(",").map(t=>t.trim()).filter(Boolean) : [];
    const r = await fetch(url,{method:editId?"PUT":"POST",headers,body:JSON.stringify({...form,bolgeler,tags:tagsArr,budget_min:sayi(form.budget_min),budget_max:sayi(form.budget_max)})});
    const d = await r.json();
    if(!r.ok){setError(d.error||"Hata");return;}
    setModal(false); fetchAll();
  };
  const sil = async (id) => { if(!window.confirm("Silinsin mi?"))return; await fetch(`${API}/customers/${id}`,{method:"DELETE",headers}); fetchAll(); };
  const eslesmeGoster = async (id) => {
    const r = await fetch(`${API}/customers/${id}/eslesme`,{headers});
    const d = await r.json();
    setEslesme(d); setEslesmeModal(true);
  };
  const whatsappGonder = (ilan) => {
    const num = cepNumarasi(eslesme?.musteri?.telefon) || String(eslesme?.musteri?.telefon||"").replace(/\D/g,"");
    if (!num || num.length < 11) { alert("Bu müşterinin geçerli bir WhatsApp/cep numarası yok."); return; }
    const satirlar = [
      `Merhaba ${eslesme.musteri.ad}, size uygun bir ilanımız var:`,
      ilan.baslik,
      `${ilan.tip==="satilik"?"Satılık":"Kiralık"} ${TIP_ADI[ilan.kategori]||ilan.kategori||""}${ilan.oda_sayisi?" | "+ilan.oda_sayisi:""}${ilan.fiyat?" | "+Number(ilan.fiyat).toLocaleString("tr-TR")+" TL":""}${(ilan.ilce||ilan.mahalle)?" | "+[ilan.ilce,ilan.mahalle].filter(Boolean).join(" / "):""}`,
    ];
    if (ilan.ana_foto) satirlar.push(`Fotoğraf: https://prestijcrm.duckdns.org${ilan.ana_foto}`);
    if (ilan.youtube_url) satirlar.push(`Video: ${ilan.youtube_url}`);
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(satirlar.join("\n"))}`, "_blank");
  };

  const inp = {width:"100%",padding:"9px 12px",background:"#0f172a",border:"1px solid #334155",borderRadius:6,color:"white",boxSizing:"border-box",fontSize:14};
  const lbl = {color:"#94a3b8",fontSize:13,marginBottom:4,display:"block"};
  const chip = (aktif) => ({padding:"6px 12px",borderRadius:20,border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f633":"#0f172a",color:aktif?"#93c5fd":"#cbd5e1",cursor:"pointer",fontSize:13,fontWeight:aktif?600:400});
  const statKart = (title,val,color) => (
    <div style={{background:"#1e293b",borderRadius:10,padding:"20px 24px",flex:1,minWidth:120,textAlign:"center"}}>
      <div style={{color:"#94a3b8",fontSize:13}}>{title}</div>
      <div style={{color:color||"#3b82f6",fontSize:28,fontWeight:700}}>{val}</div>
    </div>
  );
  const konutSecili = form.kategoriler.some(k=>KONUT.includes(k));
  const waDurum = form.phone ? (cepNumarasi(form.phone) ? "cep" : "sabit") : "";

  return (
    <div style={{padding:"24px",color:"white",minHeight:"100vh",background:"#0f172a"}}>
      <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:24}}>
        {statKart("Toplam",stats.total,"#3b82f6")}
        {statKart("Sıcak",stats.sicak,"#ef4444")}
        {statKart("Ilık",stats.ilik,"#f59e0b")}
        {statKart("Bu Ay",stats.buAy,"#10b981")}
        {statKart("Bugün",stats.bugun,"#8b5cf6")}
      </div>
      <div style={{display:"flex",gap:12,marginBottom:16,alignItems:"center",flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="İsim, telefon, bölge ara..." style={{...inp,flex:1,minWidth:180}}/>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{...inp,width:"auto"}}>
          <option value="">Tüm Durumlar</option>
          {DURUMLAR.map(d=><option key={d} value={d}>{d.charAt(0).toUpperCase()+d.slice(1)}</option>)}
        </select>
        <select value={yas} onChange={e=>setYas(e.target.value)} style={{...inp,width:"auto"}}>
          <option value="">Tüm Kayıtlar</option>
          <option value="7">Yeni (son 7 gün)</option>
          <option value="15">Son 15 gün</option>
          <option value="30">Son 30 gün</option>
          <option value="eski">Eski (6 aydan eski)</option>
        </select>
        <select value={sira} onChange={e=>setSira(e.target.value)} style={{...inp,width:"auto"}}>
          <option value="yeni">En yeni üstte</option>
          <option value="eski">En eski üstte</option>
        </select>
        <button onClick={()=>acModal()} style={{padding:"9px 18px",background:"#3b82f6",color:"white",border:"none",borderRadius:6,cursor:"pointer",fontWeight:600,whiteSpace:"nowrap"}}>+ Yeni Müşteri</button>
      </div>
      <div style={{background:"#1e293b",borderRadius:10,overflow:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:"1px solid #334155"}}>
              {["Müşteri","Kayıt Tarihi","Telefon","Aradığı","Bütçe","Bölgeler","Durum","Kaynak","İşlem"].map(h=>(
                <th key={h} style={{padding:"12px 16px",textAlign:"left",color:"#64748b",fontSize:13,fontWeight:600}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {musteriler.filter(m=>{const g=kayitBilgi(m.created_at).gun; if(yas==="7")return g<7; if(yas==="15")return g<15; if(yas==="30")return g<30; if(yas==="eski")return g>=180; return true;})
              .sort((a,b)=>sira==="eski"?new Date(a.created_at)-new Date(b.created_at):new Date(b.created_at)-new Date(a.created_at)).map(m=>(
              <tr key={m.id} style={{borderBottom:"1px solid #1e293b"}}>
                <td style={{padding:"12px 16px"}}>
                  <div style={{fontWeight:600}}>{m.name}</div>
                  <div style={{color:"#64748b",fontSize:12}}>{m.email}</div>
                  {m.tags && m.tags.length>0 && (
                    <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:4}}>
                      {m.tags.map(t=><span key={t} style={{background:"#334155",color:"#cbd5e1",fontSize:11,padding:"1px 8px",borderRadius:10}}>{t}</span>)}
                    </div>
                  )}
                </td>
                <td style={{padding:"12px 16px",whiteSpace:"nowrap"}}>{(()=>{const k=kayitBilgi(m.created_at);return(<>
                  <div style={{color:"#e2e8f0",fontSize:13}}>{k.tarih} <span style={{color:"#64748b"}}>{k.saat}</span></div>
                  <div style={{display:"flex",gap:6,alignItems:"center",marginTop:3}}>
                    <span style={{color:"#94a3b8",fontSize:12}}>{k.once}</span>
                    {k.rozet&&<span style={{background:k.rozet.r+"33",color:k.rozet.r,fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:10}}>{k.rozet.y}</span>}
                  </div></>);})()}
                </td>
                <td style={{padding:"12px 16px",color:"#94a3b8",fontSize:13}}>
                  <div>{m.phone||"—"}</div>
                  {m.whatsapp_number && <div style={{color:"#4ade80",fontSize:12}}>WA: {gosterNumara(m.whatsapp_number)}</div>}
                </td>
                <td style={{padding:"12px 16px",fontSize:13}}>
                  <div style={{color:"#e2e8f0"}}>{m.islem==="kiralik"?"Kiralık":"Satılık"}</div>
                  <div style={{color:"#94a3b8"}}>{(m.kategoriler||[]).map(k=>TIP_ADI[k]||k).join(", ")||"—"}</div>
                </td>
                <td style={{padding:"12px 16px",color:"#f59e0b",fontSize:13,whiteSpace:"nowrap"}}>
                  {m.budget_min||m.budget_max ? <>{m.budget_min?Number(m.budget_min).toLocaleString("tr-TR"):"-"} - {m.budget_max?Number(m.budget_max).toLocaleString("tr-TR"):"-"} TL</> : <span style={{color:"#64748b"}}>Belirtilmedi</span>}
                </td>
                <td style={{padding:"12px 16px"}}>
                  <div style={{display:"flex",gap:4,flexWrap:"wrap",maxWidth:220}}>
                    {((m.bolgeler&&m.bolgeler.length)?m.bolgeler:(m.district?[m.district]:[])).map(b=><span key={b} style={{background:"#0f766e33",color:"#5eead4",fontSize:11,padding:"2px 8px",borderRadius:10}}>{b}</span>)}
                    {!(m.bolgeler&&m.bolgeler.length)&&!m.district&&<span style={{color:"#64748b"}}>—</span>}
                  </div>
                </td>
                <td style={{padding:"12px 16px"}}>
                  <span style={{padding:"3px 10px",borderRadius:20,fontSize:12,fontWeight:600,background:m.status==="sicak"?"#ef444433":m.status==="ilik"?"#f59e0b33":"#33415533",color:m.status==="sicak"?"#f87171":m.status==="ilik"?"#fbbf24":"#94a3b8"}}>{m.status}</span>
                </td>
                <td style={{padding:"12px 16px",color:"#94a3b8"}}>{m.source}</td>
                <td style={{padding:"12px 16px"}}>
                  <div style={{display:"flex",gap:6}}>
                    <button onClick={()=>acModal(m)} style={{background:"#21262d",border:"1px solid #30363d",borderRadius:4,padding:"4px 8px",color:"#e6edf3",cursor:"pointer"}}>✏️</button>
                    <button onClick={()=>sil(m.id)} style={{background:"#21262d",border:"1px solid #30363d",borderRadius:4,padding:"4px 8px",color:"#e6edf3",cursor:"pointer"}}>🗑️</button>
                    {kayitBilgi(m.created_at).gun<15 && <button onClick={()=>setDisMusteri(m)} title="Sahibinden, Emlakjet, Hepsiemlak, Facebook'ta ara" style={{background:"#713f12",border:"1px solid #854d0e",borderRadius:4,padding:"4px 8px",color:"#fde68a",cursor:"pointer",whiteSpace:"nowrap"}}>🌐 Dışarıda Ara</button>}
                    <button onClick={()=>eslesmeGoster(m.id)} style={{background:"#0f766e",border:"1px solid #134e4a",borderRadius:4,padding:"4px 8px",color:"#99f6e4",cursor:"pointer",whiteSpace:"nowrap"}}>🔍 Eşleş</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100}}>
          <div style={{background:"#1e293b",borderRadius:12,padding:24,width:"94%",maxWidth:680,maxHeight:"90vh",overflowY:"auto"}}>
            <h3 style={{marginBottom:editId?4:16,fontSize:18}}>{editId?"Müşteri Düzenle":"Yeni Müşteri"}</h3>
            {editId && form.created_at && (()=>{const k=kayitBilgi(form.created_at);return <div style={{color:"#94a3b8",fontSize:13,marginBottom:16}}>Kayıt tarihi: <b style={{color:"#e2e8f0"}}>{k.tarih} {k.saat}</b> ({k.once}){k.rozet&&<span style={{marginLeft:8,background:k.rozet.r+"33",color:k.rozet.r,fontSize:11,fontWeight:700,padding:"1px 7px",borderRadius:10}}>{k.rozet.y}</span>}</div>;})()}
            {error && <div style={{background:"#ef444433",color:"#f87171",padding:"8px 12px",borderRadius:6,marginBottom:12}}>{error}</div>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:12}}>
              <div><label style={lbl}>Ad Soyad *</label><input value={form.name} onChange={e=>f("name",e.target.value)} style={inp}/></div>
              <div><label style={lbl}>Telefon</label><input value={form.phone} onChange={e=>telefonDegisti(e.target.value)} style={inp} placeholder="0532 123 45 67" inputMode="tel"/>
                {waDurum==="cep" && <div style={{color:"#4ade80",fontSize:12,marginTop:3}}>✓ Cep telefonu — WhatsApp otomatik dolduruldu</div>}
                {waDurum==="sabit" && <div style={{color:"#fbbf24",fontSize:12,marginTop:3}}>Sabit hat — WhatsApp için cep numarası girin</div>}
              </div>
              <div><label style={lbl}>WhatsApp</label><input value={form.whatsapp_number} onChange={e=>{setWaOto(false);f("whatsapp_number",e.target.value);}} style={inp} placeholder="Cep telefonu girilince otomatik" inputMode="tel"/></div>
              <div><label style={lbl}>E-posta</label><input value={form.email} onChange={e=>f("email",e.target.value)} style={inp}/></div>
            </div>

            <div style={{marginTop:16}}>
              <label style={lbl}>Satılık / Kiralık *</label>
              <div style={{display:"flex",gap:8}}>
                {[["satilik","Satılık"],["kiralik","Kiralık"]].map(([k,a])=>(
                  <button key={k} type="button" onClick={()=>f("islem",k)} style={chip(form.islem===k)}>{a}</button>
                ))}
              </div>
            </div>
            <div style={{marginTop:14}}>
              <label style={lbl}>Aradığı Mülk Tipi * <span style={{color:"#64748b"}}>(birden fazla seçilebilir)</span></label>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {MULK_TIPLERI.map(t=>(
                  <button key={t.k} type="button" onClick={()=>tipDegistir(t.k)} style={chip(form.kategoriler.includes(t.k))}>{t.a}</button>
                ))}
              </div>
            </div>
            <div style={{marginTop:14}}>
              <label style={lbl}>Aradığı Bölgeler / Semtler <span style={{color:"#64748b"}}>(yazıp Enter'a veya virgüle basın — istediğiniz kadar ekleyin)</span></label>
              <div style={{...inp,display:"flex",flexWrap:"wrap",gap:6,alignItems:"center",padding:"6px 8px"}}>
                {form.bolgeler.map(b=>(
                  <span key={b} style={{background:"#0f766e",color:"#ccfbf1",fontSize:13,padding:"3px 4px 3px 10px",borderRadius:14,display:"flex",alignItems:"center",gap:4}}>
                    {b}<button type="button" onClick={()=>bolgeSil(b)} style={{background:"transparent",border:"none",color:"#ccfbf1",cursor:"pointer",fontSize:14,padding:"0 4px"}}>×</button>
                  </span>
                ))}
                <input value={bolgeGiris} onChange={e=>{const v=e.target.value; if(/[,;]/.test(v)) bolgeEkle(v); else setBolgeGiris(v);}}
                  onKeyDown={e=>{ if(e.key==="Enter"){e.preventDefault();bolgeEkle(bolgeGiris);} else if(e.key==="Backspace"&&!bolgeGiris&&form.bolgeler.length){bolgeSil(form.bolgeler[form.bolgeler.length-1]);} }}
                  onBlur={()=>bolgeEkle(bolgeGiris)}
                  placeholder={form.bolgeler.length?"Başka bölge ekle...":"Paşaalanı, Toygar, Maltepe..."} style={{flex:1,minWidth:140,background:"transparent",border:"none",outline:"none",color:"white",fontSize:14,padding:4}}/>
              </div>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:12,marginTop:14}}>
              <div><label style={lbl}>Min Bütçe (TL)</label><input value={form.budget_min?Number(String(form.budget_min).replace(/\D/g,"")).toLocaleString("tr-TR"):""} onChange={e=>f("budget_min",e.target.value.replace(/\D/g,""))} style={inp} placeholder="2.000.000" inputMode="numeric"/></div>
              <div><label style={lbl}>Max Bütçe (TL)</label><input value={form.budget_max?Number(String(form.budget_max).replace(/\D/g,"")).toLocaleString("tr-TR"):""} onChange={e=>f("budget_max",e.target.value.replace(/\D/g,""))} style={inp} placeholder="3.000.000" inputMode="numeric"/></div>
              {konutSecili && <div><label style={lbl}>Oda Sayısı</label>
                <select value={form.rooms} onChange={e=>f("rooms",e.target.value)} style={inp}>
                  <option value="">Farketmez</option>
                  {ODALAR.map(o=><option key={o} value={o}>{o}</option>)}
                </select>
              </div>}
              <div><label style={lbl}>Amaç</label>
                <select value={form.type} onChange={e=>f("type",e.target.value)} style={inp}>
                  <option value="">Seçin</option>
                  {AMACLAR.map(a=><option key={a} value={a}>{a}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Kaynak</label>
                <select value={form.source} onChange={e=>f("source",e.target.value)} style={inp}>
                  {KAYNAKLAR.map(k=><option key={k} value={k}>{k}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Durum</label>
                <select value={form.status} onChange={e=>f("status",e.target.value)} style={inp}>
                  {DURUMLAR.map(d=><option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Sıcak Müşteri Puanı (0-100)</label>
                <input type="number" min="0" max="100" value={form.hot_score} onChange={e=>f("hot_score",e.target.value)} style={inp}/>
              </div>
            </div>
            <div style={{marginTop:12}}><label style={lbl}>Etiketler (virgülle ayırın)</label><input value={form.tags} onChange={e=>f("tags",e.target.value)} style={inp} placeholder="acil, vip, yatırımcı"/></div>
            <div style={{marginTop:12}}><label style={lbl}>Notlar</label><textarea value={form.notes} onChange={e=>f("notes",e.target.value)} style={{...inp,height:80,resize:"vertical"}}/></div>
            <div style={{display:"flex",gap:12,marginTop:20,justifyContent:"flex-end"}}>
              <button onClick={()=>setModal(false)} style={{padding:"9px 20px",background:"#374151",color:"white",border:"none",borderRadius:6,cursor:"pointer"}}>İptal</button>
              <button onClick={kaydet} style={{padding:"9px 20px",background:"#3b82f6",color:"white",border:"none",borderRadius:6,cursor:"pointer",fontWeight:600}}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {disMusteri && <DisArama musteri={disMusteri} headers={headers} kapat={()=>setDisMusteri(null)}/>}
      {eslesmeModal && eslesme && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200}}>
          <div style={{background:"#1e293b",borderRadius:12,padding:24,maxWidth:680,width:"94%",maxHeight:"88vh",overflowY:"auto"}}>
            <h3 style={{color:"#99f6e4",marginBottom:6}}>Eşleşen İlanlar — {eslesme.musteri?.ad}</h3>
            {eslesme.error && <p style={{color:"#f87171"}}>{eslesme.error}</p>}
            {eslesme.musteri && <p style={{color:"#94a3b8",fontSize:13,marginBottom:4}}>
              {eslesme.musteri.islem==="kiralik"?"Kiralık":"Satılık"} {(eslesme.musteri.kategoriler||[]).map(k=>TIP_ADI[k]||k).join(" / ")||"tüm tipler"}
              {" · "}{eslesme.musteri.butce_min||eslesme.musteri.butce_max ? `${eslesme.musteri.butce_min?Number(eslesme.musteri.butce_min).toLocaleString("tr-TR"):"-"} – ${eslesme.musteri.butce_max?Number(eslesme.musteri.butce_max).toLocaleString("tr-TR"):"-"} TL` : "bütçe belirtilmedi (hepsi listeleniyor)"}
              {(eslesme.musteri.bolgeler||[]).length>0 && <> · Bölgeler: {eslesme.musteri.bolgeler.join(", ")}</>}
            </p>}
            <p style={{color:"#3b82f6",fontWeight:600,marginBottom:12}}>{eslesme.eslesme_sayisi||0} ilan eşleşti</p>
            {eslesme.ilanlar&&eslesme.ilanlar.length===0&&<p style={{color:"#f87171"}}>Uygun ilan bulunamadı.</p>}
            {eslesme.ilanlar&&eslesme.ilanlar.map((i,idx)=>(
              <div key={i.id}>
                {(idx===0||eslesme.ilanlar[idx-1].grup!==i.grup) && (
                  <div style={{color:GRUP_RENK[i.grup],fontWeight:700,fontSize:13,margin:"14px 0 6px",borderBottom:`1px solid ${GRUP_RENK[i.grup]}55`,paddingBottom:4}}>
                    {eslesme.gruplar?.[i.grup]} ({eslesme.ilanlar.filter(x=>x.grup===i.grup).length})
                  </div>
                )}
                <div style={{background:"#0f172a",borderRadius:8,padding:12,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,borderLeft:`3px solid ${GRUP_RENK[i.grup]}`}}>
                  {i.ana_foto && <img src={`https://prestijcrm.duckdns.org${i.ana_foto}`} alt="" style={{width:64,height:48,objectFit:"cover",borderRadius:4,flexShrink:0}}/>}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:"white",fontWeight:600,fontSize:14}}>#{i.id} - {i.baslik}</div>
                    <div style={{color:"#94a3b8",fontSize:12,marginTop:4}}>
                      {TIP_ADI[i.kategori]||i.kategori}{i.oda_sayisi?` | ${i.oda_sayisi}`:""} | <span style={{color:"#fbbf24"}}>{i.fiyat?Number(i.fiyat).toLocaleString("tr-TR")+" TL":"Fiyat yok"}</span> | {[i.ilce,i.mahalle].filter(Boolean).join(" / ")||i.sehir||"-"}
                    </div>
                    <div style={{display:"flex",gap:6,marginTop:4,flexWrap:"wrap"}}>
                      {i.bolge_eslesti && <span style={{fontSize:11,color:"#5eead4"}}>📍 Aradığı bölgede</span>}
                      {i.oda_uyar && <span style={{fontSize:11,color:"#a5b4fc"}}>🛏 Oda uyuyor</span>}
                      {i.oda_bilinmiyor && <span style={{fontSize:11,color:"#fbbf24"}}>🛏 İlanda oda sayısı yok — kontrol edin</span>}
                      {i.youtube_url && <span style={{fontSize:11,color:"#f87171"}}>🎥 Video</span>}
                    </div>
                  </div>
                  <button onClick={()=>whatsappGonder(i)} style={{background:"#25D366",border:"none",borderRadius:6,padding:"8px 12px",color:"#052e16",cursor:"pointer",fontWeight:700,fontSize:13,whiteSpace:"nowrap"}}>WhatsApp Gönder</button>
                </div>
              </div>
            ))}
            <button onClick={()=>setEslesmeModal(false)} style={{marginTop:16,padding:"8px 20px",background:"#374151",color:"white",border:"none",borderRadius:6,cursor:"pointer"}}>Kapat</button>
          </div>
        </div>
      )}
    </div>
  );
}
